"use client";

import { useNativeActions } from "@/utils/useNativeActions";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useCookies } from "react-cookie";

let globalHasSignaledReady = false;

export const AppEventEmitter = ({
  clearPendingRoute = false,
}: {
  clearPendingRoute?: boolean;
}) => {
  const { appContentRendered, isCmaApp } = useNativeActions();
  const [cookies, , removeCookie] = useCookies(["pendingNativeRoute"]);
  const pathname = usePathname();

  useEffect(() => {
    if (clearPendingRoute && cookies.pendingNativeRoute === "customerHistory") {
      if (pathname === "/my-orders" || pathname === "/my-appointments") {
        removeCookie("pendingNativeRoute", { path: "/" });
      }
    }
  }, [pathname, cookies.pendingNativeRoute, removeCookie]);

  useEffect(() => {
    if (cookies.pendingNativeRoute) return;

    if (isCmaApp && !globalHasSignaledReady) {
      appContentRendered();
      globalHasSignaledReady = true;
    }
  }, [isCmaApp, appContentRendered, cookies.pendingNativeRoute]);

  return null;
};
